export default "__VITE_ASSET__DmTIJBSc__"